import React from 'react';

/* components */
import { Home } from '../../components/Home/index.js';

export const HomeContainer = () =>
    <section>
        <Home />
    </section>;
